import { createI18n } from 'vue-i18n'
import { datetimeFormats, defaultLocale, messages } from '@/i18n/options'

// Create a singleton i18n instance
let i18nInstance = null

export function appCreateI18n() {
  const currentLocale = window.location.pathname.substring(1, 3)

  i18nInstance = createI18n({
    messages,
    legacy: false,
    datetimeFormats,
    locale: currentLocale || defaultLocale,
    fallbackLocale: defaultLocale,
    missingWarn: false,
    fallbackWarn: false,
  })

  return i18nInstance
}

export function getI18nInstance() {
  if (!i18nInstance) {
    i18nInstance = appCreateI18n()
  }
  return i18nInstance
}
